import { DailyAgendaActionFactory } from '../actions';
import { WidgetComponents, WidgetElements } from '../../../../utils/bi/consts';

export type OnElementClicked = (
  component: WidgetComponents,
  element: WidgetElements,
  properties?: any,
) => void;

export const createOnElementClickedAction: DailyAgendaActionFactory<
  OnElementClicked
> = ({ biLogger }) => {
  return (component, element, properties) => {
    if (
      component === WidgetComponents.AGENDA_ITEM &&
      element === WidgetElements.BOOK_BUTTON
    ) {
      biLogger.reportContactInfoSaveSuccess();
    } else {
      biLogger.reportClick(component, element, properties);
    }
  };
};
